module.exports = "/images/cover-7.jpg";